import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/1b9c7ad5f72a1508b639eaf4b474b2ef/fcf1903d3a1b3fff5c047a5580e9fd59.png" 
              alt="SellSim" 
              className="h-12 w-auto mb-4 filter brightness-0 invert"
            />
            <p className="text-gray-300 max-w-md">
              Revolutionering sales training through AI-powered, customized solutions with role play at its core.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4">Solutions</h3>
            <ul className="space-y-3">
              <li><a href="/free-strategy-doc" className="text-gray-600 hover:text-teal-600 transition-colors">Free Strategy Doc</a></li>
              <li><a href="/custom-training" className="text-gray-600 hover:text-teal-600 transition-colors">Custom Training</a></li>
              <li><a href="/role-play" className="text-gray-600 hover:text-teal-600 transition-colors">Role-play</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 SellSim. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer mt-2 sm:mt-0"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
